import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { api, unwrap } from '@/api/client';
import { qk } from '@/api/queries';
import type { Website } from '@/api/types';
import { ResearchBlock } from './ResearchBlock';

/** /organizations/:orgId/research — «Research Data» (P2-D01–D03). */
export function OrgResearchTab() {
  const { orgId = '' } = useParams();
  return <ResearchBlock orgId={orgId} />;
}

/** /sites/:siteId/research — the same block for the site's organization (P2-D04). */
export function SiteResearchTab() {
  const { siteId = '' } = useParams();
  const site = useQuery({
    queryKey: qk.website(siteId),
    queryFn: async (): Promise<Website> => unwrap(api.GET('/admin/websites/{website_id}', { params: { path: { website_id: siteId } } })),
  }).data;
  if (!site) return null;
  return <ResearchBlock orgId={site.organization.id} siteId={site.id} />;
}
